// extracted by mini-css-extract-plugin
export var dropdownIcon = "_q0-6";
export var imgContainer = "_q0-3";
export var menuIcon = "_q0-5";
export var pillWrapper = "_q0-2";
export var pillsContainer = "_q0-1";
export var subscriptionCard = "_q0-0";
export var subscriptionLogo = "_q0-4";